export enum BlogPostType {
    PODCAST = 'podcast',
    BLOG = 'blog',
    VIDEO = 'video',
    GUIDE = 'guide',
    PRESS = 'press',
}

/**
 * Types whose listing order is curated by hand through `order_id`, instead of
 * falling back to newest-first. These are the ones the table offers move
 * up/down actions for. Mirrors `BlogPost::MANUALLY_ORDERED_TYPES` in the API.
 */
export const ManuallyOrderedBlogPostTypes: Array<BlogPostType> = [
    BlogPostType.PODCAST,
    BlogPostType.BLOG,
]
